
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/open-knowledge",
      function () {
        return require("private-next-pages/open-knowledge/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/open-knowledge"])
      });
    }
  